module.exports = __webpack_public_path__ + "static/media/menu.133dcc63.svg";